// 图片导入
import kmerpImg from "@/assets/images/kmerp.png";
import kdzsImg from "@/assets/images/kdzs.png";
import cjdzImg from "@/assets/images/cjdz.png";

import ddianImg from "@/assets/images/ddian.png";
import mgsgImg from "@/assets/images/mtsg.png";
import ksouImg from "@/assets/images/ksou.png";
import taobao3Img from "@/assets/images/taobao3.png";
import pduoduoImg from "@/assets/images/pduoduo.png";
import alibabaImg from "@assets/images/1688.png";
import jingdongImg from "@assets/images/jingdong.png";
import tmImg from "@assets/images/tm.png";
import tjb from "@assets/images/tjb.png"
import yzImg from '@assets/images/yz.png'
import jddjImg from '@assets/images/jdms.png'
import wxsphImg from "@assets/images/wxsph.png"
import sheinImg from "@assets/images/shein.png"
import DdianConf from "@/components/prod/conf/DdianConf.vue";
import KshouConf from "@/components/prod/conf/KshouConf.vue";
import PduoduoConf from "@/components/prod/conf/PduoduoConf.vue";
import TaobaoConf from "@/components/prod/conf/TaobaoConf.vue";
import TmallConf from "@/components/prod/conf/TmallConf.vue";
import AlibabaConf from "@/components/prod/conf/AlibabaConf.vue";
import JdongConf from "@/components/prod/conf/JdongConf.vue";
import TbtejiaConf from "@components/prod/conf/TbtejiaConf.vue";
import WxxdConf from "@components/prod/conf/WxxdConf.vue";
import WxsphConf from "@components/prod/conf/WxsphConf.vue";
import YzConf from "@components/prod/conf/YzConf.vue";
import XhsConf from "@components/prod/conf/XhsConf.vue";
import MtsgConf from "@components/prod/conf/MtsgConf.vue";
import XianYuConf from "@components/prod/conf/XianYuConf.vue";
import TemuConf from "@/components/prod/conf/TemuConf.vue";
import TemuBtgConf from "@/components/prod/conf/TemuBtgConf.vue";
import WdConf from "@/components/prod/conf/WdConf.vue";


const publicPath = process.env.BASE_URL;
const authSuffix = (function(window){
  return ['scm3', 'scm4', 'scm1', 'scm5'].reduce((env, currEnv) => {
    if (window.location.href.indexOf(currEnv) > -1) {
      env = `_${currEnv}`
    }
    return env
  }, '_scm')
})(window)

// 渠道 
export const CHANNELS = {
  xygyl:{
    key: 'xygyl',
    name: '星云',
    icon: kmerpImg,
  },
  // 快麦ERP
  KMERP: {
    key: 'KMERP',
    name: '快麦ERP',
    icon: kmerpImg,
  },
  // // 超级店长
  // CJDZ: {
  //   key: 'CJDZ',
  //   name: '超级店长',
  //   icon: cjdzImg,
  // }, 
  // // 快递助手
  // KDZS: {
  //   key: 'KDZS',
  //   name: '快递助手',
  //   icon: kdzsImg,
  // },
}

/*******  请在下方数组最末加入平台配置  *********/
// key -> 平台关键字符 用于后端相应接口路径｜平台tabs的name｜等
// name -> 平台中文名
// shopType -> 店铺类型
// icon -> 平台icon
// auth -> 方法 需返回店铺授权地址 (请使用async)
// reauth -> 方法（参数为已授权店铺数据）需返回店铺重新授权地址 (请使用async)
// path -> 铺货配置路由 没有path取key
// confComp -> 配置页组件
export const PLATFORMS = {
  // 抖音平台
  fxg: {
    key: 'fxg',
    name: '抖音',
    shopType: 'TouTiaoFXG',
    icon: ddianImg,
    auth: () => `https://fuwu.jinritemai.com/authorize?service_id=46&state=gyl_bindshop${authSuffix}`,
    reauth: (row) => {
      return `https://fuwu.jinritemai.com/authorize?service_id=46&state=gyl_${row.taobaoId}${authSuffix}`
    },
    path: 'ddian',
    confComp: DdianConf,
  },
  // 快手平台
  kuaishou: {
    key: 'kuaishou',
    name: "快手",
    shopType: 'KWaiShop',
    icon: ksouImg,
    auth: () => `https://s.kwaixiaodian.com/oauth/authorize?app_id=ks714102019823265828&response_type=code&scope=user_base,user_info,merchant_item,merchant_order,merchant_refund,merchant_user,merchant_logistics&redirect_uri=https://generp.superboss.cc/kuaishou/forward.do&state=gyl_bindshop${authSuffix}`,
    reauth: (row) => {
      return `https://s.kwaishop.com/oauth/authorize?app_id=ks714102019823265828&response_type=code&scope=user_base,user_info,merchant_item,merchant_order,merchant_refund,merchant_user,merchant_logistics&redirect_uri=https://generp.superboss.cc/kuaishou/forward.do&state=gyl_refresh${authSuffix}`
    },
    path: 'kshou',
    confComp: KshouConf,
  },
  // 淘宝平台
  tb: {
    key: 'tb',
    name: "淘宝",
    shopType: 'tb',
    icon: taobao3Img,
    auth: () => `https://oauth.taobao.com/authorize?response_type=code&client_id=23204092&state=1000&view=web&redirect_uri=https://erp.superboss.cc/bindshop.do?staffId=gyl_${_globel_vm.$store.getters.userInfo.staffId}_1${authSuffix}`,
    reauth: (row) => {
      return `https://oauth.taobao.com/authorize?response_type=code&client_id=23204092&state=1000&view=web&redirect_uri=https://erp.superboss.cc/refresh.do?staffId=gyl_${_globel_vm.$store.getters.userInfo.staffId}_1${authSuffix}`
    },
    confComp: TaobaoConf,
  },
  tb_xsd: {
    key: 'tb_xsd',
    name: "淘宝小时达",
    icon: 'https://erp-qd.oss-cn-hangzhou.aliyuncs.com/images/shopSource/icon_tb_xsd.png',
  },
  fxg_xsd: {
    key: 'fxg_xsd',
    name: "抖音即时零售",
    icon: 'https://p6-open-static.ecombdimg.com/tos-cn-i-o8j9kkde8i/3a21b651e0ba8aaa0f142db12d1d7bde.svg~tplv-o8j9kkde8i-image.image',
  },
  // 拼多多
  pdd: {
    key: 'pdd',
    name: "拼多多",
    shopType: 'PinShop',
    icon: pduoduoImg,
    auth: () => `http://mms.pinduoduo.com/service-market/auth?response_type=code&client_id=cf8175de7db249d29d66651d7dadf407&redirect_uri=https://erp.superboss.cc/pdd/forward.do&state=gyl_bindshop${authSuffix}`,
    reauth: (row) => {
      return `http://mms.pinduoduo.com/open.html?response_type=code&client_id=cf8175de7db249d29d66651d7dadf407&redirect_uri=https://erp.superboss.cc/pdd/forward.do&state=gyl_refresh${authSuffix}`
    },
    confComp: PduoduoConf,
  },
  // 京东
  jd: {
    key: 'jd',
    name: "京东",
    shopType: 'JdShop',
    icon: jingdongImg,
    auth: () => `https://oauth.jd.com/oauth/authorize?response_type=code&client_id=6F9FE5BF341B6F98C6FDD4D761275046&redirect_uri=https://proderp.superboss.cc/jd/forward.do&state=gyl_cjzg,6F9FE5BF341B6F98C6FDD4D761275046${authSuffix}`,
    reauth: (row) => {
      return `https://oauth.jd.com/oauth/authorize?response_type=code&client_id=6F9FE5BF341B6F98C6FDD4D761275046&redirect_uri=https://proderp.superboss.cc/jd/forward.do&state=gyl_cjzg_refresh,6F9FE5BF341B6F98C6FDD4D761275046${authSuffix}`
    },
    confComp: JdongConf,
  },
  // 1688阿里巴巴
  '1688': {
    key: '1688',
    name: "阿里巴巴",
    // shopType: '',
    icon: alibabaImg,
    auth: () => `https://auth.1688.com/oauth/authorize?client_id=3451480&site=1688&redirect_uri=https://erpa.superboss.cc/ali/forward.do&state=gyl_bindshop,3451480${authSuffix}`,
    reauth: (row) => {
      return `https://auth.1688.com/oauth/authorize?client_id=3451480&site=1688&redirect_uri=https://erpa.superboss.cc/ali/forward.do&state=gyl_refresh,3451480${authSuffix}`
    },
    confComp: AlibabaConf,
  },
  // 天猫
  tm: {
    key: 'tm',
    name: "天猫",
    shopType: 'tm',
    icon: tmImg,
    auth: () => `https://oauth.taobao.com/authorize?response_type=code&client_id=23204092&state=1000&view=web&redirect_uri=https://erp.superboss.cc/bindshop.do?staffId=gyl_${_globel_vm.$store.getters.userInfo.staffId}_1${authSuffix}`,
    reauth: (row) => {
      return `https://oauth.taobao.com/authorize?response_type=code&client_id=23204092&state=1000&view=web&redirect_uri=https://erp.superboss.cc/refresh.do?staffId=gyl_${_globel_vm.$store.getters.userInfo.staffId}_1${authSuffix}`
    },
    confComp: TmallConf,
  },
  // 淘特   待修改
  tjb: {
    key: 'tjb',
    name: '淘特',
    shopType: 'tjb',
    icon: tjb,
    auth: () => `https://oauth.taobao.com/authorize?response_type=code&client_id=23204092&state=1000&view=web&redirect_uri=https://erp.superboss.cc/bindshop.do?staffId=gyl_tjb${_globel_vm.$store.getters.userInfo.staffId}_1${authSuffix}`,
    reauth: (row) => {
      return `https://oauth.taobao.com/authorize?response_type=code&client_id=23204092&state=1000&view=web&redirect_uri=https://erp.superboss.cc/refresh.do?staffId=gyl_tjb${_globel_vm.$store.getters.userInfo.staffId}_1${authSuffix}`
    },
    confComp: TbtejiaConf,
  },
  // 有赞
  yz: {
    key: 'yz',
    name: '有赞',
    shopType: 'yz',
    icon: yzImg,
    //  return `https://diy.youzanyun.com/oauth/authorize?client_id=d0b8901b354ef026d6&response_type=code&state=${statePrefix}${
      // refresh ? 'refresh' : 'bindshop'
    // },d0b8901b354ef026d6&redirect_uri=http://erpa.superboss.cc/yz/forward.do`;
    auth: () => `https://diy.youzanyun.com/oauth/authorize?client_id=d0b8901b354ef026d6&response_type=code&state=gyl${authSuffix}_bindshop,d0b8901b354ef026d6&redirect_uri=http://erpa.superboss.cc/yz/forward.do`,
    reauth: (row) => {
      return `https://diy.youzanyun.com/oauth/authorize?client_id=d0b8901b354ef026d6&response_type=code&state=gyl${authSuffix}_refresh,d0b8901b354ef026d6&redirect_uri=http://erpa.superboss.cc/yz/forward.do`
    },
    confComp: YzConf
  },
  // 微信视频号
  wxsph: {
    key: 'wxsph',
    name: "微信小店（视频号）",
    shopType: 'wxsph',
    icon: wxsphImg,
    auth: () => '',
    reauth: (row) => {
      return ''
    },
    confComp: WxsphConf,
  },
  // 微信小店
  wxxd: {
    key: 'wxxd',
    name: '微信小店',
    shopType: 'wxxd',
    icon: `${publicPath}icons/icon_wxxd_new.png`,
    auth: () => {
      return `/wxxd/forward.json`
    },
    reauth: () => {
      return `/wxxd/forward.json`
    },
    confComp: WxxdConf,
  },
  // 微店
  wd: {
    key: 'wd',
    name: '微店',
    shopType: 'wd',
    icon: `${publicPath}icons/icon_wd_new.png`,
    auth: () => `https://h5.weidian.com/m/signin/index.html?oauth=0&redirect=https%3A%2F%2Foauth.open.weidian.com%2Foauth2%2Fauthorize%3Fappkey%3D660629%26isH5%3Dfalse%26redirect_uri%3Dhttps%3A%2F%2Ferp.superboss.cc%2Fwd%2Fforward.do%26response_type%3Dcode%26sign%3D4ec3ec809c8f8c6df289f18cb78ab660%26state%3D1`,
    reauth: () => `https://h5.weidian.com/m/signin/index.html?oauth=0&redirect=https%3A%2F%2Foauth.open.weidian.com%2Foauth2%2Fauthorize%3Fappkey%3D660629%26isH5%3Dfalse%26redirect_uri%3Dhttps%3A%2F%2Ferp.superboss.cc%2Fwd%2Fforward.do%26response_type%3Dcode%26sign%3D4ec3ec809c8f8c6df289f18cb78ab660%26state%3D1`,
    confComp: WdConf,
  },
  // 小红书
  xhs: {
    key: 'xhs',
    name: '小红书',
    shopType: 'xhs',
    icon: `${publicPath}icons/icon_xhs_new.png`,
    auth: () => `https://ark.xiaohongshu.com/ark/authorization?appId=ad637c11e4064f33a34f&redirectUri=https%3A%2F%2Ferp.superboss.cc%2Fxhs%2Fforward.do&state=auth`,
    reauth: () => `https://ark.xiaohongshu.com/ark/authorization?appId=ad637c11e4064f33a34f&redirectUri=https%3A%2F%2Ferp.superboss.cc%2Fxhs%2Fforward.do&state=auth`,
    confComp: XhsConf
  },
  // 闲鱼
  xy: {
    key: 'xy',
    name: '闲鱼',
    shopType: 'xy',
    icon: `https://erp-qd.oss-cn-hangzhou.aliyuncs.com/images/shopSource/shopSource-xy.png`,
    confComp: XianYuConf
  },
  // Temu
  pddtemu: {
    key: 'pddtemu',
    name: 'Temu',
    shopType: 'pddtemu',
    icon: `https://erp-qd.oss-cn-hangzhou.aliyuncs.com/images/shopSource/shopSource-pddtemu.png`,
    isKj:true,
    confComp: TemuConf
  },
  pddtemu_btg: {
    key: 'pddtemu_btg',
    name: 'Temu半托管',
    shopType: 'pddtemu_btg',
    icon: `https://erp-qd.oss-cn-hangzhou.aliyuncs.com/images/shopSource/shopSource-pddtemu.png`,
    isKj:true,
    confComp: TemuBtgConf
  },
  fxg_gxzy: {
    key: 'fxg_gxzy',
    name: '抖音供销平台(自研)',
    shopType: 'fxg_gxzy',
    icon: ddianImg,
  },
  fxg_gx: {
    key: 'fxg_gx',
    name: '抖音供销平台',
    shopType: 'fxg_gx',
    icon: ddianImg,
    auth: () => `https://fuwu.jinritemai.com/authorize?service_id=24964&state=bindshop${authSuffix}`,
    reauth: row => `https://fuwu.jinritemai.com/authorize?service_id=24964&state=${row.taobaoId}${authSuffix}`,
  },
  yyjk: {
    key: 'yyjk',
    name: '美团闪购平台',
    shopType: 'yyjk',
    icon: mgsgImg,
    auth: () => `https://fuwu.jinritemai.com/authorize?service_id=24964&state=bindshop${authSuffix}`,
    reauth: row => `https://fuwu.jinritemai.com/authorize?service_id=24964&state=${row.taobaoId}${authSuffix}`,
    confComp: MtsgConf
  },
  shein: {
    key: 'shein',
    name: 'Shein',
    shopType: 'shein',
    icon: sheinImg,
    // auth: () => `https://ark.xiaohongshu.com/ark/authorization?appId=ad637c11e4064f33a34f&redirectUri=https%3A%2F%2Ferp.superboss.cc%2Fxhs%2Fforward.do&state=auth`,
    // reauth: () => `https://ark.xiaohongshu.com/ark/authorization?appId=ad637c11e4064f33a34f&redirectUri=https%3A%2F%2Ferp.superboss.cc%2Fxhs%2Fforward.do&state=auth`,
    // confComp: XhsConf
  },
  ktt: {
    key: 'ktt',
    name: '快团团',
    shopType: 'ktt',
    icon: 'https://erp-qd.oss-cn-hangzhou.aliyuncs.com/images/shopSource/shopSource-ktt.png',
  },
  poison: {
    key: 'poison',
    name: '得物',
    shopType: 'poison',
    icon: `${publicPath}icons/icon_poison_new.png`,
  },
  jdms: {
    key: 'jdms',
    name: '京东到家',
    shopType: 'jdms',
    icon: jddjImg,
    // auth: () => `https://fuwu.jinritemai.com/authorize?service_id=24964&state=bindshop${authSuffix}`,
    // reauth: row => `https://fuwu.jinritemai.com/authorize?service_id=24964&state=${row.taobaoId}${authSuffix}`,
  },
}

// 其他平台店铺
export const OTHER_PLATFORMS = {
  fxg_kdzs: {
    key: 'fxg_kdzs',
    name: '抖音(快麦分销版)',
    icon: ddianImg,
    auth: () => `https://fuwu.jinritemai.com/authorize?service_id=28041&state=kmerp_gyl_bindshop${authSuffix}`,
    reauth: row => `https://fuwu.jinritemai.com/authorize?service_id=28041&state=kmerp_gyl_${row.taobaoId}${authSuffix}`,
  },
  fxg_gx: PLATFORMS['fxg_gx'],
};

// erp所有平台及对应图片名 --- 图片放在public/icons下
const ERP_ICONS_ALIAS = {
  'tjb': 'icon_taobaotjb',
  'tmcs': 'z_icon_tmcs',
  'tmgjzy': 'icon_tmgj',
  'jd_wd': 'icon_jdwd',
  'alibabac2m': 'icon_c2m',
  'pdd_wd': 'icon_pdd_wai',
  'weimeng': 'icon_wm',
  'weimobir': 'icon_wm',
  'hzw': 'icon_cekid',
  'bbtmh': 'icon_bb',
  'hyk2': 'icon_hyk',
  'duodianwulian': 'icon_duodian',
  'yhyx': 'icon_yunhuo',
  'shopee': 'icon_kj_shopee',
  'duxd': 'icon_dxd',
  'wooyingshangquan': 'shopSource-wooyingshangquan',
  'dingxiang': 'dingxiang',
  'fxg_df': 'doudiandai',
  '1889': '1889',
  'FKW': 'icon_fanke_FKW',
  'WSC': 'icon_fanke_WSC',
  'duxiaodian_tgzh': 'icon_duxd_tg',
  'shangluhua': 'icon_slh',
  'vipjit': 'icon_vip',
  'alijk': 'icon_alihealth',
}
const ERP_ICONS = [
  'tjb', 'fx', 'tmcs', 'tmgjzy',
  'twcn', 'jd_vc', 'jd_wd', 'alibabac2m',
  'pdd_wd', 'wm', 'weimeng', 'weimobir',
  'mls', 'mgj', 'sn', 'yz',
  'z800', 'ccj', 'yhd', 'vip',
  'hzw', 'wd', 'bbtmh', 'dd',
  'jp', 'gm', 'jmyp', 'mia',
  'md', 'rrd', 'kl', 'yj',
  'dvd', 'ydh', 'hyk2', 'xhs',
  'akc', 'dlj', 'gs', 'fenqile',
  'xmyp', 'ysk', 'mt', 'poison',
  'mokuai', 'tuhu', 'duodianwulian', 'omall',
  'hipac', 'yhyx', 'wwxx', 'qm',
  'thh', 'qibo', 'netease', 'cljn',
  'kml', 'qinsi', 'bilibili', 'jrbt',
  'shopee', 'haoshiqi', 'ymt', 'lazada',
  'jd_gxpt', 'wxxd', 'duxd', 'sys',
  'dangkou', 'ktt', 'wooyingshangquan', 'dingxiang',
  'smt', 'alihealth', 'hishop', 'xiaomang',
  'fxg_df', '1889', 'pajk', 'yyjk',
  'FKW', 'WSC', 'tmyp', 'duxiaodian_tgzh', 'qimen',
  'amazon', 'open', 'shein', 'alibaba_icbu',
  'weixinconnector', 'pddtemu', 'mmw', 'wswy',
  'shangluhua', 'yuncang', 'yjpop', 'vipjit',
  'alijk', 'tmgj', 'txy', 'tb_df',
].map(source => {
  const fileName = ERP_ICONS_ALIAS[source] ? `${ERP_ICONS_ALIAS[source]}_new.png` : `icon_${source}_new.png`;
  return {
    key: source,
    icon: `${publicPath}icons/${fileName}`
  }
})

const DOWNLOAD_GOODS_PLATFORMS = ['fxg', 'kuaishou', 'tb', 'pdd', 'jd', 'tm', '1688', 'yz', 'wxsph', 'wd', 'xhs','yyjk', 'xy', 'pddtemu','shein','jdms','poison'];
const PLATFORM_MAP = DOWNLOAD_GOODS_PLATFORMS.map(key => PLATFORMS[key]);

// 增加的平台店铺授权
const PLATFORM_MAP_INC = PLATFORM_MAP.concat(Object.values(OTHER_PLATFORMS));

// 平台下拉选项
export const PLATFORM_OPTIONS = PLATFORM_MAP.map(item => ({label: item.name, value: item.key}))

// 只针对店铺管理 添加的店铺
export const PLATFORM_MAP_INC_OPTIONS = PLATFORM_OPTIONS.concat(Object.keys(OTHER_PLATFORMS).map(value => ({ value, label: OTHER_PLATFORMS[value].name })));

// 平台icon_map
export const PLATFORM_ICONS_MAP = [...ERP_ICONS, ...PLATFORM_MAP_INC].reduce((map, curr) => {
  map[curr.key] = curr.icon
  return map
}, {})

// 平台的keys数组
export const PLATFORM_KEYS = PLATFORM_MAP.map(item => item.key)

export const PLATFORM_KEYS_INC = PLATFORM_KEYS.concat(Object.keys(OTHER_PLATFORMS));
export const OTHER_PLATFORM_KEYS_INC = ['sys'];

// 针对商品中心铺货平台列展示的有序的keys
export const PLATFORM_KEYS_4_COLS = (function() {
  const sortMap = {
    'fxg': 1,
    'kuaishou': 2,
    'pdd': 3,
    'tb': 4,
    'tm': 5,
    'jd': 6,
    '1688': 7
  }

  let keys = PLATFORM_MAP.map(item => item.key);
  keys.sort((a, b) => {
    const ai = sortMap[a]
    const bi = sortMap[b]

    if (!ai && !bi) {
      return 0
    } else if (!ai) {
      return 1
    } else if (!bi) {
      return -1
    } else {
      return ai - bi
    }
  })

  return keys
})()

// 平台的中文名map
export const PLATFORM_NAME_MAP = PLATFORM_MAP.reduce((map, {key, name}) => {
  map[key] = name
  return map
}, {})

// 平台的授权列表
export const PLATFORM_AUTHS = PLATFORM_MAP_INC.map(({icon, name, auth, key}) => ({
  key,
  icon,
  name,
  path: auth
}))

// 平台的重新授权map
export const PLATFORM_REAUTH_MAP = (row) => PLATFORM_MAP_INC.reduce((map, {key, reauth}) => {
  if (reauth) {
    map[key] = reauth(row)
  }
  return map
}, {})

// 平台的授权map
export const PLATFORM_AUTH_MAP = (row) => PLATFORM_MAP_INC.reduce((map, {key, auth}) => {
   if (auth) {
    map[key] = auth(row)
  }
  return map
}, {})

// 跨境平台
// export const KJ_PLATFORMS = ['pddtemu','pddtemu_btg']
// 铺货配置
const PUHUO_PLATFORMS = ['fxg', 'kuaishou', 'pdd', 'jd', 'tb', 'tm', '1688', 'yz','wxsph', 'wd', 'xhs', 'fxg_gxzy', 'fxg_gx','yyjk', 'xy', 'pddtemu','shein','ktt','jdms'];
export const PUHUO_PLATFORMS_MAP = PUHUO_PLATFORMS.map(key => PLATFORMS[key]);

// 商品平台配置配置
const PUHUO_INIT_PLATFORMS = ['fxg', 'kuaishou', 'pdd', 'jd', 'tb', 'tm', '1688', 'yz', 'wxsph', 'wd', 'xhs', 'xy','pddtemu']
export const PUHUO_INIT_PLATFORMS_MAP = PUHUO_INIT_PLATFORMS.map(key => PLATFORMS[key]);

// 更新铺货配置
const UPDATE_UPHUO_PLATFORMS = ['fxg', 'kuaishou', 'pdd', 'tb', 'jd', 'tm', '1688', 'yz','wxsph', 'wd', 'xhs', 'fxg_gxzy', 'fxg_gx','yyjk', 'xy','shein'];
export const UPDATE_UPHUO_PLATFORMS_MAP = UPDATE_UPHUO_PLATFORMS.map(key => PLATFORMS[key]);

// 全部渠道的icon
export const CHANNELS_ICONS = Object.keys(CHANNELS).reduce((map, key) => {
  map[key] = CHANNELS[key].icon
  return map
}, {});

// 全部平台的icon
export const PLATFORMS_ICONS = Object.keys(PLATFORMS).reduce((map, key) => {
  map[key] = PLATFORMS[key].icon
  return map
}, {});

// 铺货配置用到PLATFORMID
export const PLATFORMID_MAP = {
  fxg: 'TouTiaoFXG',
  kuaishou: 'KWaiShop',
  pdd: 'PinShop',
  tb: 'tb',
  jd: 'PLATFORMID',
  tm: 'tm',
  '1688': '1688',
  yz: 'yz',
  wxsph: 'wxsph',
  xhs: 'xhs',
  xy: 'xy',
  pddtemu: 'pddtemu'
}

